class FormElements {

    static apply() {

        document.querySelectorAll( '.c-form-element' ).forEach( (element) => {
            this.create(element);
        });
    }

    static create( element ) {

        const input = element.querySelector('input, textarea, select');

        if ( input ){

            input.addEventListener('input', this.updateIsFilled);
			input.addEventListener('input', this.updateIsFocused);
			input.addEventListener('blur', this.updateIsFocused);
			input.addEventListener('blur', this.updateIsFilled);
			input.addEventListener('focus', this.updateIsFocused);
			input.addEventListener('animationstart', this.onAnimationStart, false);


            if ( input.disabled ) {
                element.classList.add('is-disabled');
            }

            this.dispatchInput(input);
        }
    }

    static dispatchInput( element ) {
        const event = new Event('input', {"bubbles":true, "cancelable":false});
        element.dispatchEvent(event);
    }

    static onAnimationStart( {target, animationName} ) {

        if ( animationName === 'onAutoFillStart' ) {
            target.closest('.c-form-element').classList.add('is-filled');
        }
    }

    static updateIsFilled(event) {

        if ( ( event.target.value.length > 0 ) ){
            event.target.closest('.c-form-element').classList.add('is-filled');
        }
        else {
            event.target.closest('.c-form-element').classList.remove('is-filled');
        }
    }

    static updateIsFocused(event) {

        if ( event.target === document.activeElement ){
            event.target.closest('.c-form-element').classList.add('is-focused');
        }
        else {
            event.target.closest('.c-form-element').classList.remove('is-focused');
        }
    }
}

export default FormElements;

/*
---
name: FormElements
category: JavaScript
subcategory: Helpers
tags: [javascript]
---
Adding event to inputs in a container with the class 'c-form-element'. With the events floating inputs are supported.

Initialize
======

```js
import { FormElements } from '@nutshell/core';

FormElements.apply();
```
*/
